import styled from "styled-components";
import { cssVariables } from "constants/css";

const Canvas = styled.div<{noPadding?: boolean}>`
  width: 100%;
  margin: 0 auto;
  padding: 42px 24px;
  max-width: ${cssVariables.midContainerWidth};

  @media (min-width: ${cssVariables.windowBreakpoint}) {
    max-width: ${cssVariables.largeContainerWidth};
  }
  
  ${({ noPadding }) => (noPadding ? `
    padding-top: 0;
    padding-bottom: 0;
  ` : "")}

  @media print {
    max-width: 100% !important;
    padding: ${cssVariables.gUnit};
  }
`;

export default Canvas;
